"use strict";
var React = require("react");
var AddDepartmentModal = require("./AddDepartmentModal");
var EditDepartmentModal = require("./EditDepartmentModal");
var DeleteDepartmentModal = require("./DeleteDepartmentModal");
var CompanyActions = require("../../../actions/CompanyActions");
var CompanyStore = require("../../../stores/CompanyStore");
var Button = require("react-bootstrap").Button;
var _ = require("underscore");
var clone = require("clone");

var DepartmentItem = React.createClass({
    getInitialState(){
      return {
        showEditModal: false,
        showDeleteModal: false,
        showAddModal: false,
        department: {},
      };
    },
    close() {
      this.setState({ showEditModal: false });
    },
    open(department) {
      this.setState({
        department: department,
        showEditModal: true,
      });
    },
    closeDelete() {
      this.setState({ showDeleteModal: false });
    },
    openDelete(department) {
      this.setState({
        department: department,
        showDeleteModal: true,
      });
    },
    closeAdd() {
      this.setState({ showAddModal: false });
    },
    openAdd(department) {
      this.setState({
        department: department,
        showAddModal: true,
      });
    },
    mapIcons: function(tree) {
      return (
        <li key={tree.id}>
          <div className="tree-item">
            <div className="tree-item-name">{tree && tree.name}</div>
            <div className="tree-item-buttons">
              <button className="tree-button" type="button" title="Bæta við hérna" onClick={() => this.openAdd(tree)}>
                <span className="md md-add"/>
              </button>
              <button className="tree-button" type="button" title="Breyta" onClick={() => this.open(tree)}>
                <span className="md md-mode-edit"/>
              </button>
              <button className="tree-button" type="button" title="Eyða" onClick={() => this.openDelete(tree)}>
                <span className="md md-delete"/>
              </button>
            </div>
          </div>
          <ul>
            {(tree && tree.children && tree.children.length !== 0) ?
              tree.children.map((children) =>
                this.mapIcons(children)
              )
            :
              null
            }
          </ul>
        </li>
      );
    },
    render: function() {
      return (
        <ul className="first-ul">
          <AddDepartmentModal parent={this.state.department} show={this.state.showAddModal} onHide={this.closeAdd} />
          <EditDepartmentModal department={this.state.department} show={this.state.showEditModal} onHide={this.close} />
          <DeleteDepartmentModal department={this.state.department} show={this.state.showDeleteModal} onHide={this.closeDelete} />
          {this.props.tree.map((treeItem) => {
            return this.mapIcons(treeItem);
          })}
        </ul>
      );
    }
});

var DepartmentsTab = React.createClass({
    getInitialState: function(){
      var storeState = CompanyStore.getState();
      var departments = storeState.departments;
      var tree = this.makeTree(departments);

      return {
        departments: departments,
        showModal: false,
        departmentTree: tree
      };
    },
    componentDidMount: function() {
        CompanyStore.listen(this.onChange);
    },
    componentWillUnmount: function() {
        CompanyStore.unlisten(this.onChange);
    },
    onChange: function() {
        this.setState(this.getInitialState());
    },
    makeTree(data) {
        var departments = _.indexBy(clone(data), 'id');

        var unflatten = function( array, parent, tree ){

            tree = typeof tree !== 'undefined' ? tree : [];
            parent = typeof parent !== 'undefined' ? parent : { id: null };

            var children = _.filter( array, function(child){
              // Check if parent is in our list, if its not we set parent as null
              if(!departments[child.parent]){
                  child.parent = null;
              }
              return child.parent == parent.id;
            });

            if (!_.isEmpty(children)) {
              if (parent.id == null) {
                tree = children;
              } else{
                parent['children'] = children
              }
              _.each( children, function(child){ unflatten( array, child ) } );
            }
            return tree;
        }

        var tree = unflatten(data);
        return tree;
    },
    close(){
      this.setState({ showModal: false });
    },
    open () {
      this.setState({ showModal: true });
    },
    render: function() {
        var departments = this.state.departments;
        return (
          <div className="row">
            <div className="settings-header col-xs-12">
              <h3>Deildir</h3>
              <AddDepartmentModal show={this.state.showModal} onHide={this.close} />
              <Button className="page-scroll btn btn-xl" onClick={this.open}>Bæta við deild</Button>
            </div>
            <div className="settings-body col-xs-12">
              <div className="row departmentManagementList">
                <div className="tree-list">
                  <DepartmentItem department={this.state.departmentTree[0]} tree={this.state.departmentTree} />
                </div>
              </div>
            </div>
          </div>
        );
    }
});

module.exports = DepartmentsTab;



// WEBPACK FOOTER //
// ./app/scripts/ui/Settings/Departments/DepartmentsTab.react.js